import "./responsive.css";

function Layout({ children }) {
  return (
    <div className="app-page">
      <div className="page-container">
        {children}
      </div>
    </div>
  );
}

export default Layout;